import { inject, Injectable } from '@angular/core';
import { ApiService } from '../other/api';
import { HttpClient } from '@angular/common/http';
import { Notification } from '../../models/Notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private http = inject(HttpClient);
  private api = new ApiService<Notification>(this.http);

  getList(params?: any) {
    return this.api.getList('functions/getMyNotifications', params);
  }

  getObjectById(id: string) {
    return this.api.getSingle('functions/getMyNotifications', id);
  }

  saveFcmToken(object: any) {
    return this.api.add('functions/saveFcmToken', object);
  }

}